import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function FAQ() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    phone: '',
    petType: '',
    petAge: '',
    concern: '',
    message: ''
  });
  const [waitlistForm, setWaitlistForm] = useState({
    name: '',
    email: '',
    phone: '',
    petInfo: ''
  });
  const [contactSubmitting, setContactSubmitting] = useState(false);
  const [contactSuccess, setContactSuccess] = useState(false);
  const [waitlistSubmitting, setWaitlistSubmitting] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const faqs = [
    {
      q: '홉 CBD는 대마에서 나온 건가요?',
      a: '아닙니다. 홉 CBD는 맥주의 원료로 잘 알려진 홉(Humulus kriya)에서 추출한 것입니다. 대마와 같은 식물 계통이지만 완전히 다른 식물이며, THC는 전혀 함유하지 않습니다. 화학적 구조는 대마 CBD와 동일하지만 원료가 다릅니다.'
    },
    {
      q: '우리 아이에게 오래 먹여도 안전한가요?',
      a: '12주 장기 투여 시험에서 간 효소(ALT, AST) 수치 변화가 없었고, 심혈관계, 신경계 등에서도 이상 소견이 발견되지 않았습니다. 다만 개별 반려동물의 건강 상태에 따라 다를 수 있으므로, 수의사와 상담 후 사용하시고 정기적인 건강 검진을 병행하시길 권장합니다.'
    },
    {
      q: '어떤 아이에게는 쓰면 안 되나요?',
      a: '임신 중이거나 수유 중인 반려동물, 간이나 신장 질환이 있는 경우, 수술 예정인 경우에는 사용 전 반드시 수의사와 상담해야 합니다. 또한 다른 약물을 복용 중인 경우 약물 상호작용 가능성을 확인해야 합니다.'
    },
    {
      q: 'CBD를 먹으면 우리 아이가 취하거나 이상해지나요?',
      a: '전혀 그렇지 않습니다. CBD는 THC와 달리 정신활성 작용이 없습니다. 환각, 취함, 중독 등의 증상은 나타나지 않으며, 반려동물의 정상적인 행동과 의식에 영향을 주지 않습니다.'
    },
    {
      q: '효과를 보려면 얼마나 먹여야 하나요?',
      a: '반려동물의 체중, 증상의 정도, 개체 차이에 따라 다릅니다. 일반적으로 2~4주 정도 꾸준히 사용했을 때 효과를 느낄 수 있습니다. 낮은 용량부터 시작하여 점진적으로 조절하는 것이 좋으며, 수의사의 지도 하에 사용하시길 권장합니다.'
    },
    {
      q: '다른 약과 함께 먹여도 되나요?',
      a: '대부분의 경우 안전하지만, 일부 약물과 상호작용할 가능성이 있습니다. 특히 항경련제, 진통제, 항불안제 등을 복용 중이라면 반드시 수의사와 상담 후 사용하세요. 임의로 기존 약물을 중단하거나 용량을 조절하지 마세요.'
    },
    {
      q: '부작용은 없나요?',
      a: '대부분의 반려동물에게 안전하지만, 드물게 졸림, 식욕 변화, 설사 등의 경미한 증상이 나타날 수 있습니다. 이러한 증상은 대부분 일시적이며 용량 조절로 개선됩니다. 심각한 부작용이 나타나면 즉시 사용을 중단하고 수의사와 상담하세요.'
    },
    {
      q: '강아지와 고양이 모두 사용할 수 있나요?',
      a: '네, 모든 포유류는 엔도카나비노이드 시스템을 가지고 있어 CBD의 효과를 받을 수 있습니다. 다만 고양이는 강아지보다 대사 속도가 다르므로 용량 조절에 더 주의가 필요합니다.'
    },
    {
      q: '언제 출시되나요? 어디서 구매할 수 있나요?',
      a: '현재 출시 준비 중이며, 정확한 출시일은 추후 공지 예정입니다. 출시 알림을 신청하시면 가장 먼저 소식을 받아보실 수 있습니다. 출시 후에는 우리 병원을 통해 구매 및 상담이 가능합니다.'
    },
    {
      q: '가격은 얼마인가요?',
      a: '제품 라인업과 가격은 출시 시점에 공개될 예정입니다. 합리적인 가격으로 보호자 여러분께 제공할 수 있도록 준비 중입니다. 출시 알림을 신청하시면 가격 정보도 함께 안내드립니다.'
    }
  ];

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: '반려동물 CBD - 걱정없이 힐링포벳에서',
    description: '[홉에서 추출한 THC 0%] 우리 아이의 치매, 발작, 불안, 관절 통증, 피부 문제를 케어합니다. 안전하고 효과적인 CBD를 만나보세요.',
    keywords: 'CBD, 홉 CBD, 반려동물 CBD, 강아지 CBD, 고양이 CBD, 펫 케어, 반려동물 건강, 치매, 발작, 불안, 관절염, 피부 케어',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.a
        }
      }))
    }
  });

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setContactSubmitting(true);

    const formData = new URLSearchParams();
    formData.append('name', contactForm.name);
    formData.append('email', contactForm.email);
    formData.append('phone', contactForm.phone);
    formData.append('petType', contactForm.petType);
    formData.append('petAge', contactForm.petAge);
    formData.append('concern', contactForm.concern);
    formData.append('message', contactForm.message);

    try {
      const response = await fetch('https://readdy.ai/api/form/d4j6sp33rief4cfea9k0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setContactSuccess(true);
        setContactForm({
          name: '',
          email: '',
          phone: '',
          petType: '',
          petAge: '',
          concern: '',
          message: ''
        });
        setTimeout(() => setContactSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setContactSubmitting(false);
    }
  };

  const handleWaitlistSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setWaitlistSubmitting(true);

    const formData = new URLSearchParams();
    formData.append('name', waitlistForm.name);
    formData.append('email', waitlistForm.email);
    formData.append('phone', waitlistForm.phone);
    formData.append('petInfo', waitlistForm.petInfo);

    try {
      const response = await fetch('https://readdy.ai/api/form/d4j6sp33rief4cfea9kg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setWaitlistSuccess(true);
        setWaitlistForm({
          name: '',
          email: '',
          phone: '',
          petInfo: ''
        });
        setTimeout(() => setWaitlistSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setWaitlistSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-16 bg-white">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-light text-gray-900 mb-6">자주 묻는 질문</h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            홉 CBD에 대해 궁금하신 점을 확인하세요
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-white border border-gray-200">
                <button
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
                  data-event={`faq_toggle_${idx}`}
                >
                  <span className="text-lg font-medium text-gray-900 pr-4">{faq.q}</span>
                  <i className={`ri-arrow-${openFaq === idx ? 'up' : 'down'}-s-line text-2xl text-gray-600 flex-shrink-0`}></i>
                </button>
                {openFaq === idx && (
                  <div className="px-8 pb-6">
                    <p className="text-gray-700 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact-form" className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-light text-gray-900 mb-4">상담 문의</h2>
            <p className="text-gray-600">우리 아이에게 맞는 솔루션을 찾아드립니다</p>
          </div>
          <form onSubmit={handleContactSubmit} className="bg-gray-50 border border-gray-200 p-12" data-readdy-form>
            <div className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-2">보호자 성함 *</label>
                  <input
                    type="text"
                    name="name"
                    value={contactForm.name}
                    onChange={(e) => setContactForm({...contactForm, name: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-2">이메일 *</label>
                  <input
                    type="email"
                    name="email"
                    value={contactForm.email}
                    onChange={(e) => setContactForm({...contactForm, email: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm"
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-2">연락처 *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={contactForm.phone}
                    onChange={(e) => setContactForm({...contactForm, phone: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-2">반려동물 종류 *</label>
                  <select
                    name="petType"
                    value={contactForm.petType}
                    onChange={(e) => setContactForm({...contactForm, petType: e.target.value})}
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm appearance-none bg-white cursor-pointer"
                  >
                    <option value="">선택해주세요</option>
                    <option value="강아지">강아지</option>
                    <option value="고양이">고양이</option>
                    <option value="기타">기타</option>
                  </select>
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-2">반려동물 나이</label>
                  <input
                    type="text"
                    name="petAge"
                    value={contactForm.petAge}
                    onChange={(e) => setContactForm({...contactForm, petAge: e.target.value})}
                    placeholder="예: 5살"
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-2">주요 고민 *</label>
                  <select
                    name="concern"
                    value={contactForm.concern}
                    onChange={(e) => setContactForm({...contactForm, concern: e.target.value})}
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm appearance-none bg-white cursor-pointer"
                  >
                    <option value="">선택해주세요</option>
                    <option value="인지기능·치매">인지기능·치매</option>
                    <option value="발작·뇌전증">발작·뇌전증</option>
                    <option value="불안·분리불안">불안·분리불안</option>
                    <option value="관절·통증">관절·통증</option>
                    <option value="피부·아토피">피부·아토피</option>
                    <option value="기타">기타</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">상세 내용</label>
                <textarea
                  name="message"
                  value={contactForm.message}
                  onChange={(e) => setContactForm({...contactForm, message: e.target.value})}
                  rows={6}
                  maxLength={500}
                  placeholder="우리 아이의 증상이나 궁금하신 점을 자유롭게 작성해주세요 (최대 500자)"
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm resize-none"
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">
                  {contactForm.message.length}/500
                </div>
              </div>
              {contactSuccess && (
                <div className="bg-green-50 border border-green-200 p-4 text-sm text-green-800">
                  문의가 성공적으로 접수되었습니다. 빠른 시일 내에 연락드리겠습니다.
                </div>
              )}
              <button
                type="submit"
                disabled={contactSubmitting}
                className="w-full px-8 py-4 bg-gray-900 text-white hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer disabled:bg-gray-400"
                data-event="cta_contact_submit"
              >
                {contactSubmitting ? '전송 중...' : '상담 신청하기'}
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Waitlist Form */}
      <section id="waitlist-form" className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-light text-gray-900 mb-4">출시 알림 신청</h2>
            <p className="text-gray-600">제품 출시 소식을 가장 먼저 받아보세요</p>
          </div>
          <form onSubmit={handleWaitlistSubmit} className="bg-white border border-gray-200 p-12" data-readdy-form>
            <div className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-2">성함 *</label>
                  <input
                    type="text"
                    name="name"
                    value={waitlistForm.name}
                    onChange={(e) => setWaitlistForm({...waitlistForm, name: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-900 mb-2">이메일 *</label>
                  <input
                    type="email"
                    name="email"
                    value={waitlistForm.email}
                    onChange={(e) => setWaitlistForm({...waitlistForm, email: e.target.value})}
                    required
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">연락처 *</label>
                <input
                  type="tel"
                  name="phone"
                  value={waitlistForm.phone}
                  onChange={(e) => setWaitlistForm({...waitlistForm, phone: e.target.value})}
                  required
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">반려동물 정보</label>
                <input
                  type="text"
                  name="petInfo"
                  value={waitlistForm.petInfo}
                  onChange={(e) => setWaitlistForm({...waitlistForm, petInfo: e.target.value})}
                  placeholder="예: 5살 골든리트리버"
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-gray-900 text-sm"
                />
              </div>
              {waitlistSuccess && (
                <div className="bg-green-50 border border-green-200 p-4 text-sm text-green-800">
                  알림 신청이 완료되었습니다. 출시 소식을 가장 먼저 알려드리겠습니다.
                </div>
              )}
              <button
                type="submit"
                disabled={waitlistSubmitting}
                className="w-full px-8 py-4 bg-gray-900 text-white hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer disabled:bg-gray-400"
                data-event="cta_waitlist_submit"
              >
                {waitlistSubmitting ? '전송 중...' : '알림 신청하기'}
              </button>
            </div>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}
